export default {
  Common: {
    PleaseNote: 'Please note',
    AddVisit: 'Add a visit',
    DayShort: {
      Sun: 'Sun',
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
    },
    DayFull: {
      Sun: 'Sunday',
      Mon: 'Monday',
      Tue: 'Tuesday',
      Wed: 'Wednesday',
      Thu: 'Thursday',
      Fri: 'Friday',
      Sat: 'Saturday',
    },
    CareLabels: {
      Morning: 'morning care',
      Evening: 'evening care',
      Overnight: 'overnight care',
      Generic: 'care',
    },
  },
  ScheduleStep: {
    FormDefinitionTitle: 'Schedule',
    FormDefinitionDescription: 'Client weekly schedule preferences.',
    FormQuestionLabel: 'Care schedule',
    CreateCarePlan: 'Create Care Plan',
  },
  TitleCard: {
    Title: 'Flexible Pricing',
    Description: 'We believe quality care shouldn\'t come with complicated tiers. Rates are based on the length of your commitment, not the complexity of the care. You will always work with caregivers who are trained to handle all your loved one\'s needs.',
  },
  ScheduleCard: {
    Title: 'Schedule',
    Description: 'Schedule has a major influence on the matching process and the final cost. Please ensure this is accurate before requesting caregiver profiles.',
    CustomSchedule: 'Custom schedule',
    EditCare: 'Edit #{careLabel}',
  },
  ExpectedCostCard: {
    Title: 'Expected cost',
    NoEstimateMessage: 'Complete your schedule details above to see your personalized estimate here.',
    FromWeeklyAmount: 'From $#{weeklyAmount} per week / $#{monthlyAmount} per month',
    BasedOn: 'Based on',
    HoursPerWeek: '#{hoursPerWeek} hours per week',
    And: 'and',
    QuarterlyBooking: 'a quarterly booking.',
    FinalQuoteNotice: 'You will receive a final quote prior to booking care.',
  },
  PlansCard: {
    Title: 'Plans',
    Description: 'Booking ahead helps you keep a consistent caregiver and reduces your hourly rate.',
    RecommendedForYou: 'Recommended for you',
    QuarterlyTitle: 'Quarterly: $35/hr',
    QuarterlySubtitle: 'Best value',
    QuarterlyDescription: 'Fixed quarterly schedule with the same caregiver(s) for the duration of your booking.*',
    MonthToMonthTitle: 'Month-To-Month: $45/hr',
    MonthToMonthSubtitle: 'Most popular',
    MonthToMonthDescription: 'Fixed monthly schedules with the same caregiver(s) for the duration of your booking.*',
    WeekToWeekTitle: 'Week-To-Week: $55/hr',
    WeekToWeekSubtitle: 'Most flexible',
    WeekToWeekDescription: 'Flexible schedules, caregivers matched based on availability.',
    PricingNote: '*Speak with your care manager for more details on pricing.',
  },
  ScheduleEventEditFlexible: {
    Title: 'Set your flexible schedule',
    PreferredDayOptional: 'Preferred day (optional)',
    PreferredTimeOfDayOptional: 'Preferred time of day (optional)',
    VisitDurationNeeded: 'Visit duration needed*',
    VisitDurationPlaceholder: '3 hours',
    ShortShiftNotice: 'A longer shift will help you find the best caregiver match. Caregivers have a strong preference for visits of 3 hours or longer.',
    RemoveAriaLabel: 'Remove',
    SaveVisitButton: 'Save visit details',
    StepLabel: 'Step 2 of 2',
    DayOptions: {
      AnyDay: 'Any day',
      Sun: 'Sun',
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
    },
    TimeOptions: {
      AnyTime: 'Any time',
      Morning: 'Morning',
      Afternoon: 'Afternoon',
      Evening: 'Evening',
      Overnight: 'Overnight',
    },
  },
  ScheduleEventEditRecurring: {
    Title: 'Set your recurring schedule',
    StartTime: 'Start Time*',
    EndTime: 'End Time*',
    Repeats: 'Repeats',
    StartDate: 'Start date*',
    EndDateOptional: 'End Date (Optional)',
    ShortShiftNotice: 'A longer shift will help you find the best caregiver match. Caregivers have a strong preference for visits of 3 hours or longer.',
    RemoveAriaLabel: 'Remove',
    AddVisitButton: 'Save visit details',
    StepLabel: 'Step 2 of 2',
  },
  ScheduleEventEditOncall: {
    Title: 'On-call',
    Description: 'No schedule needed right now. We\'ll add you to our on-call pool and match you with a caregiver whenever something comes up - usually within a few hours.',
    TypicalVisitLength: 'Typical visit length',
    VisitLengthPlaceholder: 'Select',
    VisitLengthOptions: {
      FewHours: 'A few hours',
      HalfDay: 'Half a day',
      FullDay: 'A full day',
      Overnight: 'Overnight',
      NotSureYetOrByTheHour: 'Not sure yet or by the hour',
    },
    RemoveAriaLabel: 'Remove',
    SaveButton: 'Save visit details',
    StepLabel: 'Step 2 of 2',
  },
  ScheduleEventDisplayRecurring: {
    RecurringSuffix: ' - Recurring',
  },
  ScheduleEventDisplayFlexible: {
    FlexibleSuffix: ' - Flexible',
    DurationLabel: 'Duration',
    TimeLabel: 'Time',
    DurationFallback: '-',
    TimeFallback: '-',
  },
  ScheduleEventDisplayOncall: {
    TitleFallback: 'On-call',
    DurationLabel: 'Duration',
    DurationFallback: 'A few hours',
  },
  ScheduleEventAdd: {
    Title: 'Do you have a schedule in mind?',
    Description: 'Choose the best option that describes your situation',
    StepLabel: 'Step 1 of 2',
    RecurringTitle: 'Recurring schedules',
    RecurringDescription: 'Set specific days and hours with the same caregiver(s). Best for consistent weekly care.',
    FlexibleTitle: 'Flexible schedule',
    FlexibleDescription: 'Same days, flexible timing or open days, set times. We\'ll find the best fit.',
    OnCallTitle: 'On-call',
    OnCallDescription: 'Not sure yet? We\'ll match based on caregiver availability when you need it.',
    ContinueButton: 'Continue',
  },
};
